import {
ADD_FILE_REQUEST_RECORD_ERROR,
ADD_FILE_REQUEST_RECORD_WATCHER,
ADD_FILE_REQUEST_RECORD_SUCCESS
  } from "../actionTypes/index";
  export const AddFileRequestRecordWatcher = (payload, resolve, reject) => {
    return { type: ADD_FILE_REQUEST_RECORD_WATCHER, payload, resolve, reject };
  };
  
  export const AddFileRequestRecordSuccess = (payload, resolve, reject) => {
    return { type: ADD_FILE_REQUEST_RECORD_SUCCESS, payload, resolve, reject };
  };
  
  export const addFileRequestRecordError = (payload, resolve, reject) => {
    return { type: ADD_FILE_REQUEST_RECORD_ERROR, payload, resolve, reject };
  };
  